<template>
  <div>
    <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <!-- <v-col cols="1">
          <v-btn icon dark disabled="">
            <v-icon size="28px"> mdi-arrow-left-bold-box-outline </v-icon>
          </v-btn>
        </v-col>-->
        <v-col cols="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="add_form = true"
                :disabled="selectedRows.length > 0"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-file-plus-outline</v-icon>
                <span class="lable_class">Add</span>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                class="ml-7 header_btn"
                @click="edit_form = true"
              >
                <v-icon size="28px">mdi-clipboard-edit-outline</v-icon>
                <span class="lable_class">Edit</span>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled class="ml-7 header_btn">
                <v-icon size="28px">mdi-eye-outline</v-icon>
                <span class="lable_class">View</span>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0 || open_doc_model_falg || open_log_model_falg"
                @click="delete_dialog = true"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-delete-outline</v-icon>
                <span class="lable_class">Delete</span>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-col>
        <v-col cols="2" class="d-flex align-center">
          <!-- <v-menu bottom offset-y :close-on-content-click="false" v-model="search_menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn :disabled="open_doc_model_falg || open_log_model_falg" icon small dark v-bind="attrs" v-on="on" class="mr-1">
                <v-badge overlap dot :value="search || pagination.filters.alphabet" color="error">
                  <v-icon size="28px">mdi-magnify</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile width="400">
              <v-row no-gutters>
                
              <v-col cols="12">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                  solo
                  clearable
                  autofocus
                  v-on:keyup.enter="search_menu = false"
                ></v-text-field>
              </v-col>
              </v-row>
            </v-card>
          </v-menu>-->

          <v-menu
            bottom
            :close-on-content-click="false"
            content-class="elevation-0"
            v-model="filter_menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="pagination.filters.alphabet = ''"
                :disabled="open_doc_model_falg || open_log_model_falg"
                dark
                icon
                v-bind="attrs"
                v-on="on"
                class="ml-7 header_btn"
              >
                <span class="lable_class">Filter</span>
                <v-icon size="22px">mdi-filter-menu-outline</v-icon>
              </v-btn>
            </template>
            <v-card tile max-width="400" class="mb-5 mr-5">
              <v-list class="filter-section-border">
                <v-list-item class="mt-0">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    hide-details
                    dense
                    outlined
                    placeholder=" "
                    clearable
                    autofocus
                    v-on:keyup.enter="search_menu = false"
                    class="mr-2"
                  ></v-text-field>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="error"
                        @click="resetFilter()"
                        icon
                        small
                      >
                        <v-icon size="20" class="white--text">mdi-filter-remove-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Reset</span>
                  </v-tooltip>
                </v-list-item>
                <v-list-item class="mt-1">
                  <v-autocomplete
                    dense
                    flat
                    :items="status"
                    outlined
                    label="Status"
                    hide-details
                    class="body-2"
                    placeholder=" "
                    v-model="pagination.filters.item_active"
                  ></v-autocomplete>
                </v-list-item>
                <v-list-item class="mt-1">
                  <v-autocomplete
                    dense
                    flat
                    :items="account_type_list"
                    outlined
                    label="Account Type"
                    hide-details
                    class="body-2"
                    placeholder="All"
                    v-model="pagination.filters.account_type"
                    clearable
                  ></v-autocomplete>
                </v-list-item>
              </v-list>
              <v-card-title class="pa-0">
                <v-btn
                  fab
                  color="error"
                  x-small
                  absolute
                  @click="filter_menu = false"
                  class="custom-close-btn"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
          </v-menu>
        </v-col>
        <v-col cols="2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="openDocList(selectedRows[0])"
                :disabled="selectedRows.length != 1"
                class="ml-7 header_btn"
              >
                <span class="lable_class">Documents</span>
                <v-badge
                  color="error"
                  :content="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''"
                  :value="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''"
                  overlap
                >
                  <v-icon size="28px">mdi-dresser-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Documents</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="openLogList(selectedRows[0])"
                :disabled="selectedRows.length != 1"
                class="ml-7 header_btn"
              >
                <v-badge
                  color="error"
                  :content="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].logs_count:''"
                  :value="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].logs_count:''"
                  overlap
                >
                  <span class="lable_class">Logs</span>
                  <v-icon size="22px">mdi-file-document-multiple-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Logs</span>
          </v-tooltip>
        </v-col>
        <v-col cols="2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length < 1 || open_doc_model_falg || open_log_model_falg"
                @click="getAccountBalance('multi','')"
                class="ml-1 header_btn"
              >
                <v-icon size="28px">mdi-calculator-variant-outline</v-icon>
                <span class="lable_class">Balance</span>
              </v-btn>
            </template>
            <span>Balance</span>
          </v-tooltip>
        </v-col>
        <v-col cols="3" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">
            Chart Of Account
            <v-icon
              class="error--text ml-2"
              size="30"
              style="color:#ffffff !important"
              @click="logout()"
            >mdi-logout</v-icon>
          </span>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading">
      <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
    <v-card tile style="background: none" flat width="auto">
      <v-card-text class="pa-0 mx-auto">
        <v-row dense style="width:100%" class="pa-0 ma-0">
          <v-col cols="2" class="pt-0 pr-0 alphabet-sort-max-width">
            <v-row dense class="alphabet-section">
              <v-col cols="12" class="text-center">
                <v-btn
                  elevation="2"
                  max-width="22"
                  min-width="22"
                  height="20"
                  small
                  style="font-size:15px;"
                  :class="(pagination.filters.alphabet == '')?'primary':''"
                  class="text-capitalize"
                  @click="pagination.filters.alphabet = ''"
                >All</v-btn>
              </v-col>

              <v-col
                cols="12"
                v-for="(alphabet, index) in alphabets"
                :key="index"
                class="text-center pa-0"
                :style="alphabet.text == 'Z' 
                  ? 'padding-top: 1px !important; padding-bottom: 11px !important;' 
                  : 'padding-bottom: 2px !important;'"
              >
                <v-btn
                  elevation="2"
                  max-width="22"
                  min-width="22"
                  height="20"
                  small
                  style="font-size:14px;"
                  :disabled="alphabet.disable"
                  :class="(pagination.filters.alphabet == alphabet.value) ? 'primary' : ''"
                  @click="pagination.filters.alphabet = alphabet.value"
                >{{ alphabet.text }}</v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pt-0 pr-0">
            <v-data-table
              :headers="headers"
              class="full-footer-bar elevation-1 rounded-0 my-transaction-table fix-table-layout fix-table-header custom-width-1328"
              :search="search"
              :items="items.data"
              :server-items-length="items.total"
              :options.sync="pagination"
              dense
              mobile-breakpoint="50"
              item-key="bank_id"
              :footer-props="{
                'items-per-page-options': pagination_settings.perPageList,
              }"
            >
              <template v-slot:item="{ item, index }">
                <tr :class="(!item.account_active)?'red lighten-5':''">
                  <td width="3%">
                    <v-icon
                      v-if="item.is_system_bank != 1"
                      @click="editRecord(item.bank_id,false)"
                      :disabled="open_doc_model_falg || open_log_model_falg"
                    >mdi-clipboard-edit-outline</v-icon>
                  </td>
                  <td width="3%">
                    <v-simple-checkbox
                      v-if="item.is_system_bank != 1"
                      v-model="item.selected"
                      :ripple="false"
                      class="custom-simple-box"
                      @input="selectRecord(item.bank_id)"
                    ></v-simple-checkbox>
                  </td>
                  <td width="20%">{{item.bank_name}}</td>
                  <td width="11%">{{item.bank_code}}</td>
                  <td width="11%">{{(item.acctype)?item.acctype.acc_type:''}}</td>
                  <td width="9%">{{item.date_of_opening_balance}}</td>
                  <td width="11%" class="pl-5 pr-5 text-right">
                    <span
                      v-if="item.opening_balance"
                      :class="{
                        'error--text': item.opening_balance < 0,
                        'primary--text': item.opening_balance > 0,
                      }"
                    >${{ getAmountFormat(item.opening_balance) }}</span>
                  </td>
                  <td width="11%" class="text-right">
                    <span
                      v-if="item.account_balance_flag==true"
                      :class="{
                        'error--text': item.balance   < 0,
                        'primary--text': item.balance > 0,
                      }"
                    >{{ item.balance > 0 ? '$'+ getAmountFormat(item.balance) : '' }}</span>
                    <v-btn
                      icon
                      x-small
                      v-else
                      href
                      class="pr-10"
                      @click="getAccountBalance('single',item.bank_id)"
                    >view</v-btn>
                  </td>
                  <td width="9%" class="text-center">
                    <v-switch
                      v-if="item.acctype.acc_type_id=='21' || item.acctype.acc_type_id=='23'"
                      class="pt-0 ma-0 pl-3"
                      v-model="item.profit_loss"
                      color="success"
                      @change="updateItem(index)"
                      dense
                      hide-details
                    ></v-switch>
                  </td>
                  <td width="12%">
                    <v-icon
                      @click="editRecord(item.bank_id,true)"
                      :disabled="open_doc_model_falg || open_log_model_falg"
                    >mdi-eye-outline</v-icon>
                  </td>
                </tr>
              </template>
              <template v-slot:item.ac_type="{ item }">
                <span v-if="item.ac_type">{{ item.acctype.acc_type }}</span>
              </template>
              <template v-slot:item.opening_balance="{ item }">
                <span v-if="item.opening_balance">${{ item.opening_balance }}</span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="add_form" max-width="550" persistent>
      <v-card class="mx-auto align-self-stretch" tile :loading="add_form_loading" width="100%">
        <v-card-title class="headline pb-0">Add Account</v-card-title>
        <v-card-text class="pa-2 pt-0 mt-0">
          <v-container class="pt-1">
            <v-form>
              <v-row>
                <v-col cols="9" class="pa-2 pb-1">
                  <v-text-field
                    label="Account Name"
                    dense
                    autofocus
                    v-model="form_data.bank_name"
                    :error-messages="form_error.bank_name"
                    :hide-details="!form_error.bank_name"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" class="pa-2 pb-1">
                  <v-text-field
                    label="Short Code"
                    dense
                    v-mask="'XXXXXXX'"
                    v-model="form_data.bank_code"
                    :error-messages="form_error.bank_code"
                    :hide-details="!form_error.bank_code"
                    class="capitalize-whole-letter"
                  ></v-text-field>
                </v-col>
                <v-col cols="4" style="max-width: 24%;" class="d-flex align-center">
                  <v-radio-group
                    v-model="form_data.amount_type"
                    row
                    hide-details
                    class="mt-0"
                    dense
                  >
                    <v-radio label="Cr" value="PLUS" class="ma-0 pa-0"></v-radio>
                    <v-radio label="Dr" value="MINUS" class="ma-0 pa-0 pl-2"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col class="pa-2 pb-1">
                  <v-text-field
                    label="Opening Balance"
                    dense
                    type="number"
                    v-model="form_data.opening_balance"
                    :error-messages="form_error.opening_balance"
                    :hide-details="!form_error.opening_balance"
                    prepend-inner-icon="mdi-currency-usd"
                    :color="(form_data.amount_type == 'MINUS')?'red':'green'"
                    :class="(form_data.amount_type == 'MINUS')?'red-font-color':'green-font-color'"
                  ></v-text-field>
                </v-col>
                <v-col cols="5" class="pa-2 pb-1">
                  <v-menu
                    v-model="date_of_opening_balance"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form_data.date_of_opening_balance"
                        label="Date of Opening Balance"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        dense
                        :error-messages="form_error.date_of_opening_balance"
                        :hide-details="!form_error.date_of_opening_balance"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dateFormatted"
                      @input="date_of_opening_balance = false; parseDate()"
                      no-title
                      scrollable
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="8" class="pa-2 pb-1">
                  <v-select
                    :items="account_types"
                    label="Acc. Type"
                    dense
                    v-model="form_data.ac_type"
                    :error-messages="form_error.ac_type"
                    :hide-details="!form_error.ac_type"
                  ></v-select>
                </v-col>
                <v-col cols="4" class="pa-2 pb-1">
                  <v-text-field
                    label="Acc. Group"
                    dense
                    v-model="form_data.ac_group"
                    :error-messages="form_error.ac_group"
                    :hide-details="!form_error.ac_group"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="form_data.keywords"
                    label="Keywords (comma separated)"
                    dense
                    :error-messages="form_error.keywords"
                    :hide-details="!form_error.keywords"
                    rows="1"
                  ></v-textarea>
                </v-col>
                <v-col cols="3" class="pa-2 pb-0">
                  <v-switch
                    class="pt-0 ma-0"
                    v-model="form_data.account_active"
                    label="Active"
                    color="success"
                    dense
                    hide-details
                  ></v-switch>
                </v-col>
                <v-col cols="9" class="pa-2 pb-0">
                  <v-switch
                    v-if="form_data.ac_type=='21' || form_data.ac_type=='23'"
                    class="pt-0 ma-0"
                    v-model="form_data.profit_loss"
                    label="Profit & Loss"
                    color="success"
                    dense
                    hide-details
                  ></v-switch>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" dark @click="add_form = false">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click="saveAccount" :loading="add_form_loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="edit_form" max-width="562" persistent content-class="elevation-0">
      <v-card
        class="mx-auto align-self-stretch mb-5 mr-5"
        tile
        :loading="edit_form_loading"
        max-width="550"
      >
        <v-card-title class="headline pb-0">{{(is_view_mode)?'Account Details':'Edit Account'}}</v-card-title>
        <v-card-text class="pa-2 pt-0">
          <v-container class="pt-1">
            <v-form :readonly="is_view_mode">
              <v-row>
                <v-col cols="9" class="pa-2 pb-1">
                  <v-text-field
                    label="Account Name"
                    dense
                    autofocus
                    v-model="edit_form_data.bank_name"
                    :error-messages="edit_form_error.bank_name"
                    :hide-details="!edit_form_error.bank_name"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" class="pa-2 pb-1">
                  <v-text-field
                    label="Short Code"
                    v-mask="'XXXXXXX'"
                    dense
                    v-model="edit_form_data.bank_code"
                    :error-messages="edit_form_error.bank_code"
                    :hide-details="!edit_form_error.bank_code"
                    class="capitalize-whole-letter"
                  ></v-text-field>
                </v-col>
                <v-col cols="4" style="max-width: 24%;" class="d-flex align-center">
                  <v-radio-group
                    v-model="edit_form_data.amount_type"
                    row
                    hide-details
                    class="mt-0"
                    dense
                  >
                    <v-radio label="Cr" value="PLUS" class="ma-0 pa-0"></v-radio>
                    <v-radio label="Dr" value="MINUS" class="ma-0 pa-0 pl-2"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="4" class="pa-2 pb-1">
                  <v-text-field
                    label="Opening Balance"
                    dense
                    type="number"
                    v-model="edit_form_data.opening_balance"
                    :error-messages="edit_form_error.opening_balance"
                    :hide-details="!edit_form_error.opening_balance"
                    prepend-inner-icon="mdi-currency-usd"
                    :color="(edit_form_data.amount_type == 'MINUS')?'red':'green'"
                    :class="(edit_form_data.amount_type == 'MINUS')?'red-font-color':'green-font-color'"
                  ></v-text-field>
                </v-col>
                <v-col cols="5" class="pa-2 pb-1">
                  <v-menu
                    v-model="date_of_opening_balance2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="edit_form_data.date_of_opening_balance"
                        label="Date of Opening Balance"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        dense
                        :error-messages="edit_form_error.date_of_opening_balance"
                        :hide-details="!edit_form_error.date_of_opening_balance"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dateFormatted2"
                      @input="date_of_opening_balance2 = false; parseDate2()"
                      no-title
                      scrollable
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="8" class="pa-2 pb-1">
                  <v-select
                    :items="account_types"
                    label="Acc. Type"
                    dense
                    v-model="edit_form_data.ac_type"
                    :error-messages="edit_form_error.ac_type"
                    :hide-details="!edit_form_error.ac_type"
                  ></v-select>
                </v-col>
                <v-col cols="4" class="pa-2 pb-1">
                  <v-text-field
                    label="Acc. Group"
                    dense
                    v-model="edit_form_data.ac_group"
                    :error-messages="edit_form_error.ac_group"
                    :hide-details="!edit_form_error.ac_group"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="edit_form_data.new_keywords"
                    label="Keywords (comma separated)"
                    dense
                    :error-messages="edit_form_error.new_keywords"
                    :hide-details="!edit_form_error.new_keywords"
                    rows="1"
                  >
                    <template v-slot:prepend>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            size="22"
                            v-bind="attrs"
                            v-on="on"
                            @click="keyword_dialog = true"
                          >mdi-eye-outline</v-icon>
                        </template>
                        <span>View Exist Keyword</span>
                      </v-tooltip>
                    </template>
                  </v-textarea>
                </v-col>

                <v-col cols="3" class="pa-2 pb-0 pt-1">
                  <v-switch
                    class="pt-0 ma-0"
                    v-model="edit_form_data.account_active"
                    label="Active"
                    color="success"
                    dense
                    hide-details
                  ></v-switch>
                </v-col>
                <v-col cols="9" class="pa-2 pb-0 pt-1">
                  <v-switch
                    v-if="edit_form_data.ac_type=='21' || edit_form_data.ac_type=='23'"
                    class="pt-0 ma-0"
                    v-model="edit_form_data.profit_loss"
                    label="Profit & Loss"
                    color="success"
                    dense
                    hide-details
                  ></v-switch>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="pa-0" v-if="is_view_mode">
          <v-btn
            fab
            color="error"
            x-small
            absolute
            @click="edit_form = false "
            class="custom-close-btn"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-btn color="error" dark @click="edit_form = false">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!is_view_mode"
            color="primary"
            dark
            @click="saveEditedAccount"
            :loading="edit_form_loading"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_dialog" max-width="430">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete selected chart of accounts?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_dialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" text @click="delete_dialog = false; deleteItems()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="keyword_dialog" max-width="350" persistent>
      <v-card class="mx-auto align-self-stretch" tile :loading="keyword_loading" width="100%">
        <v-card-title class="headline pa-2">Keyword(s)</v-card-title>
        <v-card-text class="pa-2 pt-0" style="font-weight: 500;">
          <v-row
            dense
            v-if="edit_form_data.keywords && edit_form_data.keywords.length > 0"
            class="light-green lighten-4 primary--text"
          >
            <v-col
              cols="12"
              class="pt-2"
              v-for="(keyword, index) in edit_form_data.keywords"
              :key="index"
            >
              <v-btn
                class="mx-2"
                fab
                dark
                x-small
                width="22"
                height="22"
                color="primary"
                v-if="!is_view_mode"
                @click="deleteKeyword(keyword)"
              >
                <v-icon small>mdi-close</v-icon>
              </v-btn>
              <span class="ml-2">{{ keyword.title }}</span>
            </v-col>
          </v-row>
          <v-row dense v-else>
            <v-col cols="12">No Any Eixst Keyword!</v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" dark @click="keyword_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DocList />
    <LogList />
  </div>
</template>

<script>
import axios from "../../plugins/axios";
import { mapMutations, mapState } from "vuex";
import { parseParams, logout } from "../../plugins/helper";
import DocList from "../document/List";
import LogList from "../log/List";
export default {
  name: "ProjectList",
  data() {
    return {
      open_doc_model_falg: false,
      open_log_model_falg: false,
      search: "",
      loading: false,
      delete_dialog: false,
      keyword_dialog: false,
      keyword_loading: false,
      add_form: false,
      edit_form: false,
      is_view_mode: false,
      date_of_opening_balance: false,
      date_of_opening_balance2: false,
      filter_menu: false,
      dateFormatted: null,
      dateFormatted2: null,
      items: {
        data: []
      },
      status: [
        { text: "All", value: "all" },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" }
      ],
      pagination: {
        itemsPerPage: 25,
        sortBy: ["bank_name"],
        page: 1,
        filters: {
          item_active: "1",
          alphabet: "",
          account_type: ""
        }
      },
      alphabets: [],
      expanded: [],
      add_form_loading: false,
      edit_form_loading: false,
      bank_id: false,
      form_data: {
        account_active: true,
        profit_loss: true
      },
      form_error: {},
      edit_form_data: {
        ac_type: null,
        account_active: true,
        profit_loss: true,
        bank_code: "",
        amount_type: null
      },
      edit_form_error: {},
      p_type: [
        { text: "Fixed", value: "fixed" },
        { text: "Cost Plus", value: "cost_plus" },
        { text: "Project Management", value: "project_management" }
      ],
      account_types: [],
      account_type_list: [],
      search_menu: false
    };
  },
  components: {
    LogList,
    DocList
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    ...mapState("document", ["doc_list_modal", "refresh_doc_list"]),
    ...mapState("log", ["log_list_modal", "refresh_log_list"]),
    selectedRows() {
      return this.items.data.filter(function(item) {
        return item.selected == true;
      });
    },
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.searchOption = "bank_name";
      return paginationData;
    },
    getStyles() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return {
          maxWidth: "95%",
          margin: "0 auto"
        };
      } else {
        return {};
      }
    },
    headers() {
      return [
        { value: "", text: "", sortable: false, width: "3%" },
        {
          value: "checkbox",
          text: "#",
          sortable: false,
          width: "3%",
          class: "pl-3"
        },
        { value: "bank_name", text: "Name", sortable: true, width: "20%" },
        {
          value: "bank_code",
          text: "Short Code",
          sortable: true,
          width: "11%"
        },
        { value: "ac_type", text: "Type", width: "11%" },
        {
          value: "date_of_opening_balance",
          text: "Date",
          width: "9%",
          class: "pl-3"
        },
        {
          value: "opening_balance",
          text: "Op. Balance",
          width: "11%",
          align: "right"
        },
        { value: "balance", text: "Balance", width: "11%", align: "right" },
        { value: "profit_loss", text: "Profit & Loss", width: "9%" },
        { value: "", text: "", sortable: false, width: "12%" }
      ];
    }
  },
  watch: {
    doc_list_modal: function(value) {
      if (!value) {
        this.open_doc_model_falg = false;
      } else {
        this.open_doc_model_falg = true;
      }
    },
    log_list_modal: function(value) {
      if (!value) {
        this.open_log_model_falg = false;
      } else {
        this.open_log_model_falg = true;
      }
    },
    search() {
      this.getAccounts();
    },
    pagination: {
      handler: function() {
        this.getAccounts();
      },
      deep: true
    },
    add_form: {
      handler: function(val) {
        if (!val) {
          this.form_data = {
            account_active: true,
            profit_loss: true
          };
          this.form_error = {};
        }
      }
    },
    edit_form: {
      handler: function(val) {
        if (!val) {
          this.edit_form_data = {
            ac_type: null
          };
          this.edit_form_error = {};
        } else {
          this.getBank();
        }
      }
    }
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    ...mapMutations("document", ["setModal", "setDocumentData"]),
    ...mapMutations("log", ["setLogData"]),
    updateItem(index) {
      axios
        .post("edit_account", this.items.data[index])
        .then(function() {})
        .catch(function(error) {
          console.log("FAILURE!!", error);
        });
    },
    selectRecord(val) {
      if (this.open_doc_model_falg || this.open_log_model_falg) {
        this.items.data.filter(item => {
          if (val == item.bank_id) {
            if (this.open_doc_model_falg && this.open_log_model_falg) {
              this.setDocumentData({
                key: "refresh_doc_list",
                value: !this.refresh_doc_list
              });
              this.setLogData({
                key: "refresh_log_list",
                value: !this.refresh_log_list
              });
              this.openDocList(item);
              this.openLogList(item);
              setTimeout(() => {
                this.openDocList(item);
                this.openLogList(item);
              }, 500);
            } else if (this.open_doc_model_falg) {
              this.setDocumentData({
                key: "refresh_doc_list",
                value: !this.refresh_doc_list
              });
              this.openDocList(item);
            } else if (this.open_log_model_falg) {
              this.setLogData({
                key: "refresh_log_list",
                value: !this.refresh_log_list
              });
              this.openLogList(item);
            }
          } else {
            item.selected = false;
          }
        });
      }
    },
    openDocList(item) {
      this.setDocumentData({ key: "doc_list_modal", value: true });
      this.setDocumentData({ key: "type", value: 4 });
      this.setDocumentData({ key: "o_id", value: item.bank_id });
      this.setDocumentData({ key: "item", value: item });
      this.setDocumentData({ key: "main_task_id", value: "0" });
      this.setDocumentData({ key: "child_task_id", value: "0" });
      this.setDocumentData({ key: "form_name", value: "Chart Of Account" });
      this.setDocumentData({ key: "item_name", value: "" });
      this.setDocumentData({ key: "job_name", value: "" });
      this.setDocumentData({ key: "user_name", value: "" });
      this.setDocumentData({ key: "customer_name", value: "" });
      this.setDocumentData({ key: "doc_module", value: "ACCOUNT" });
      this.setDocumentData({ key: "bank_name", value: item.bank_name });
      this.setDocumentData({ key: "project_name", value: "" });
      this.setDocumentData({ key: "vendor_name", value: "" });
    },
    openLogList(item) {
      this.setLogData({ key: "log_list_modal", value: true });
      this.setLogData({ key: "type", value: 4 });
      this.setLogData({ key: "o_id", value: item.bank_id });
      this.setLogData({ key: "item", value: item });

      this.setLogData({ key: "form_name", value: "Chart Of Account" });
      this.setLogData({ key: "item_name", value: "" });
      this.setLogData({ key: "job_name", value: "" });
      this.setLogData({ key: "user_name", value: "" });
      this.setLogData({ key: "customer_name", value: "" });
      this.setLogData({ key: "bank_name", value: item.bank_name });
      this.setLogData({ key: "project_name", value: "" });
      this.setLogData({ key: "vendor_name", value: "" });
    },
    editRecord(bank_id, is_view_mode) {
      this.bank_id = bank_id;
      this.edit_form = true;
      this.is_view_mode = is_view_mode;
    },
    parseDate() {
      const [year, month, day] = this.dateFormatted.split("-");
      this.form_data.date_of_opening_balance = `${month.padStart(
        2,
        "0"
      )}/${day.padStart(2, "0")}/${year}`;
    },
    parseDate2() {
      const [year, month, day] = this.dateFormatted2.split("-");
      this.edit_form_data.date_of_opening_balance = `${month.padStart(
        2,
        "0"
      )}/${day.padStart(2, "0")}/${year}`;
    },
    deleteKeyword(keyword) {
      this.keyword_loading = true;
      let _self = this;
      axios
        .post("delete_keyword", keyword)
        .then(response => {
          if (response.data.status) {
            _self.edit_form_data.keywords = _self.edit_form_data.keywords.filter(
              function(eKeyword) {
                return eKeyword.keyword_id != keyword.keyword_id;
              }
            );
          }
        })
        .catch(function() {})
        .then(function() {
          _self.keyword_loading = false;
        });
    },
    getAmountFormat(value) {
      if (value) {
        return value.replace("-", "");
      } else {
        return "";
      }
    },
    expandRow(itemData) {
      if (itemData.value) {
        this.items.data = this.items.data.map(function(item) {
          if (item.bank_id == itemData.item.bank_id) {
            item.selected = true;
          }
          return item;
        });
      }
    },
    deleteItems() {
      let _self = this;
      let ids = [];
      this.selectedRows.map(function(item) {
        ids.push(item.bank_id);
      });
      axios
        .post("delete_account", {
          ids: ids
        })
        .then(function(response) {
          if (response.data.message != "") {
            _self.setAlert({
              show: true,
              variant: "error",
              message: response.data.message,
              dismissCountDown: 0
            });
          }
          _self.getAccounts();
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },
    getFormatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    getAccountBalance(type, id) {
      let _self = this;
      this.loading = "accent";
      let ids = [];
      if (type == "single") {
        ids.push(id);
      } else {
        this.selectedRows.map(function(item) {
          ids.push(item.bank_id);
        });
      }
      axios
        .get("get_account_balance?account_ids=" + ids)
        .then(response => {
          this.items.data = this.items.data.filter(item => {
            response.data.data.filter(fil => {
              if (item.bank_id == fil.bank_id) {
                item.opening_balance = fil.opening_balance;
                item.balance = fil.balance;
                item.account_balance_flag = true;
              }
            });
            return item;
          });
          this.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    getAccounts() {
      let _self = this;
      this.loading = "accent";
      let url = parseParams(this.pageData);
      axios
        .get("account_list?" + url)
        .then(response => {
          if (_self.items.total != response.data.data.total) {
            _self.pagination.page = 1;
          }
          _self.items = response.data.data;
          _self.alphabets = response.data.alphabets;
          _self.account_type_list = response.data.account_types;
          _self.account_type_list.push("HARD CODE");
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    getAlphabets() {
      this.loading = true;
      axios.get("get_alphabets?flag=account").then(response => {
        if (response.data.status) {
          this.alphabets = response.data.data;
        }
        this.loading = false;
      });
    },
    getAccountTypes() {
      axios.get("get_account_types").then(response => {
        if (response.data.status) {
          this.account_types = response.data.data;
        }
      });
    },
    saveAccount() {
      this.add_form_loading = true;
      this.form_error = {};
      let _self = this;
      let serverData = JSON.parse(JSON.stringify(this._data.form_data));
      axios
        .post("add_account", serverData)
        .then(function(res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
            _self.pagination.filters.alphabet = "";
            _self.resetFilter();
            _self.add_form = false;
          }
          _self.add_form_loading = false;
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
          _self.add_form_loading = false;
        });
    },
    resetFilter() {
      this.search = "";
      this.pagination.filters.item_active = "1";
      this.pagination.filters.account_type = "";
      this.getAccounts();
    },
    getBank() {
      this.edit_form_loading = true;
      let _self = this;
      axios.get("get_account?id=" + _self.bank_id).then(function(res) {
        if (res.data.status) {
          let data = res.data.data;
          for (let key in data) {
            _self.edit_form_data[key] = data[key];
          }
          _self.edit_form_data.opening_balance = _self.getAmountFormat(
            _self.edit_form_data.opening_balance
          );
        }
        _self.edit_form_loading = false;
      });
    },
    saveEditedAccount() {
      this.edit_form_loading = true;
      this.edit_form_error = {};
      let _self = this;
      let serverData = JSON.parse(JSON.stringify(this._data.edit_form_data));
      axios
        .post("edit_account", serverData)
        .then(function(res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.edit_form_error[key] = data.errors[key][0];
            }
          } else {
            _self.getAccounts();
            _self.edit_form = false;
          }
          _self.edit_form_loading = false;
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
          _self.edit_form_loading = false;
        });
    },
    logout() {
      logout(this.$router);
    }
  },
  mounted: function() {
    this.getAccountTypes();
    //this.getAlphabets();
  }
};
</script>

<style>
</style>